export default [
  { label: 'userDefined', value: 'false' },
  { label: 'componentPassThrough', value: 'true' },
];
